export type RuntimeMode = 'demo' | 'db';

const rawMode = String((import.meta as any).env?.VITE_APP_MODE || 'demo').toLowerCase();

export const runtimeMode: RuntimeMode = rawMode === 'db' ? 'db' : 'demo';
export const isDemoMode = runtimeMode === 'demo';
export const isDbMode = runtimeMode === 'db';
